import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth';
import { ErrorBox, Field } from '../components/ui';
import { useI18n } from '../i18n';

export function LoginPage() {
  const { login } = useAuth();
  const { t, lang, setLang } = useI18n();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page">
      <form className="card login-card stack" onSubmit={submit}>
        <div>
          <img className="logo" src="/logo.png" alt="Translation Centre" />
          <p className="title">{t('login.title')}</p>
        </div>
        <ErrorBox error={error} />
        <Field label={t('login.email')} htmlFor="email">
          <input id="email" className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </Field>
        <Field label={t('login.password')} htmlFor="password">
          <input id="password" className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </Field>
        <button className="btn btn-primary" type="submit" disabled={busy} style={{ minHeight: 44 }}>
          {busy ? t('common.wait') : t('login.submit')}
        </button>
        <div className="row" style={{ justifyContent: 'center' }}>
          <button type="button" className="btn btn-sm btn-ghost" onClick={() => setLang(lang === 'sq' ? 'en' : 'sq')}>
            {lang === 'sq' ? 'English' : 'Shqip'}
          </button>
        </div>
      </form>
    </div>
  );
}
